
import Vue from 'vue'
import Router from 'vue-router'
import App from '../App'
import { path } from 'animejs'

const index = () => import('../views/index/index.vue')
const about = () => import('../views/about/about.vue')
const download = () => import('../views/download/download.vue')
const cases = () => import('../views/cases/cases.vue')
const product = () => import('../views/product/product.vue')
const plan = () => import('../views/plan/plan.vue')
const news = () => import('../views/news/news.vue')
const empty = () => import('../views/empty/empty.vue')
const phoneIndex = () => import('../views/phone/phoneIndex/phoneIndex.vue')
const phoneProduct = () => import('../views/phone/phoneProduct/phoneProduct.vue')
const phonePlan = () => import('../views/phone/phonePlan/phonePlan.vue')
const phoneCase = () => import('../views/phone/phoneCase/phoneCase.vue')
const phoneDownload = () => import('../views/phone/phoneDownload/phoneDownload.vue')
const phoneAbout = () => import('../views/phone/phoneAbout/phoneAbout.vue')
const phoneEntry = () => import('../views/phone/phoneEntry/phoneEntry.vue')
const phoneNews = () => import('../views/phone/phoneNews/phoneNews.vue')

// 重写push以免重复点击本路由报错
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error=> error)
}

Vue.use(Router);
const router = [
    {
        path:'/',
        name:'App',
        component:App,        
        redirect:'/index.html', 
        children: [
          {
            path:'/',
            component:index,
            name:'index',
            meta:{
              title:'abc'
            }
          },
          {
            path:'/index.html',
            component:index,
            name:'index',
            meta:{
              title:'abc'
            }
          },
          {
            path:'/about.html',
            component:about,
            name:'about'
          },
          {
            path:'/download.html',
            component:download,
            name:'download'
          },
          {
            path:'/cases.html',
            component:cases,
            name:'cases'
          },
          {
            path:'/product.html',
            component:product,
            name:'product'
          },
          {
            path:'/plan.html',
            component:plan,
            name:'plan'
          },
          {
            path:'/news.html',
            component:news,
            name:'news'
          },
          {
            path:'/empty.html',
            component:empty,
            name:'empty'
          },
          {
            path:"*",
            redirect:"/index.html"
          }
        ]
    },
    {
        path:'/phoneEntry.html',
        component:phoneEntry,
        name:'phoneEntry',        
        children:[
          // {
          //   path:'/',
          //   component:phoneIndex,
          //   name:'phoneIndex'
          // },
           {
            path:'/phoneIndex.html',
            component:phoneIndex,
            name:'phoneIndex'
           },
           {
             path:'/phoneProduct.html',
             component:phoneProduct,
             name:'phoneProduct'
            },
            {
             path:'/phonePlan.html',
             component:phonePlan,
             name:'phonePlan'
            },
            {
             path:'/phoneCase.html',
             component:phoneCase,
             name:'phoneCase'
            },
            {
             path:'/phoneDownload.html',
             component:phoneDownload,
             name:'phoneDownload'
            },
            {
             path:'/phoneAbout.html',
             component:phoneAbout,
             name:'phoneAbout'
            },
            {
             path:'/phoneNews.html',
             component:phoneNews,
             name:'phoneNews'
            },
            {
              path:'/empty.html',
              component:empty,
              name:'empty'
            },
        ]
    },
  
    
  
]

export default new Router({
  mode:'history',
  routes: router
})
